import { IApplicationState } from '../../types/redux';

export const isConsultantChatOpenedSelector = (state: IApplicationState) => state.consultantCianChat.isOpened;
